export class AccessibilityElement extends Phaser.Events.EventEmitter {
  constructor(container, ariaLabel, { x, y, width, height }) {
    super();
    this._container = container;
    this._element = this._createElement(ariaLabel, x, y, width, height);
    this._element.controller = this;
    this._container.appendChild(this._element);
  }

  get element() {
    return this._element;
  }

  set x(value) {
    this._element.style.left = value + 'px';
  }

  set y(value) {
    this._element.style.top = value + 'px';
  }

  setPosition(x, y) {
    this.x = x;
    this.y = y;
  }

  set width(value) {
    this._element.style.width = value + 'px';
  }

  set height(value) {
    this._element.style.height = value + 'px';
  }

  setSize(width, height) {
    this.width = width;
    this.height = height;
  }

  focus() {
    this.emit('focus');
  }
  blur() {
    this.emit('blur');
  }
  select() {
    this.emit('select');
  }

  _createElement(ariaLabel, x, y, width, height) {
    const element = document.createElement('button');
    element.setAttribute('aria-label', ariaLabel);
    element.setAttribute('tabindex', 1);
    element.setAttribute('role', 'button');
    element.style.top = y + 'px';
    element.style.left = x + 'px';
    element.style.width = width + 'px';
    element.style.height = height + 'px';
    return element;
  }

  destroy() {
    this._container.removeChild(this._element);
    this._element.controller = null;
    this._element = null;
    this._container = null;
    super.destroy();
  }
}
